import { Component, EventEmitter, Input, OnDestroy, OnInit, Output, ViewEncapsulation } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-step-phone-number',
  templateUrl: './step-phone-number.component.html',
  styleUrls: ['./step-phone-number.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class StepPhoneNumberComponent implements OnInit, OnDestroy {
  @Input() form: FormGroup;
  @Input() migration: boolean;

  @Output() nextStep: EventEmitter<void> = new EventEmitter();

  phoneNumberStep: number;
  subscriptions = new Subscription();

  ngOnInit(): void {
    if (this.migration) {
      this.form.get('phoneNumberStep').disable();
      this.subscriptions.add(
        this.form
          .get('migrate')
          .get('agreed')
          .valueChanges.subscribe(value => {
            if (!value) {
              this.form.get('migrate').get('agreed').setValue(null, { emitEvent: false });
            }
          })
      );
    }
  }

  tryToNext() {
    if (this.migration) {
      this.nextStep.emit();
    } else {
      const { phoneNumberStep } = this.form.value;
      // Only the first choice can direclty go to the next step.
      if (phoneNumberStep === 1) {
        this.nextStep.emit();
      } else {
        this.phoneNumberStep = phoneNumberStep;
      }
    }
  }

  backToChoices() {
    this.phoneNumberStep = null;
  }

  ngOnDestroy(): void {
    this.subscriptions?.unsubscribe();
  }
}
